import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiResponse } from '@app/shared/models';
import { SelectOption } from '@app/shared/models/multiselect-options.model';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import COUNTRIES from './countries.json';

@Injectable({ providedIn: 'root' })
export class HttpService {
    private readonly httpClient = inject(HttpClient);

    getCountriesList(): Observable<SelectOption[]> {
        const countriesList: SelectOption[] = COUNTRIES.map((country) => ({
            name: `country.${country.Code.toLocaleLowerCase()}`,
            value: country.Code.toLocaleLowerCase(),
        }));

        return of(countriesList);
    }

    getVoivodeship(): Observable<SelectOption[]> {
        return this.httpClient
            .get<ApiResponse<{ terytCode: string; namePl: string }[]>>('api/public/polish-voivodeships')
            .pipe(map((response) => response.data.map((voivodeship) => ({ name: voivodeship.namePl, value: voivodeship.terytCode }))));
    }
}
